import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import { GB_FEATURE_KEYS } from '~/services/abTests/features';

export const useIsPaypalAvailable = (hasPaypalApi: boolean): boolean => {
  const isPaypalPaymentEnabled = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.PAYPAL_PAYMENT,
  );

  return Boolean(hasPaypalApi) && isPaypalPaymentEnabled;
};
